import environment from "Configs/environment";
import axios from "axios";
import { useSnackbar } from "material-ui-snackbar-provider";
import { useCallback, useEffect, useRef } from "react";
import { CustomParameters } from "./SnackbarProvider";
import { useTranslation } from "./TranslationProvider";

const POLLING_INTERVAL = 1000 * 60;
const TIME_UNTIL_REALOAD = 1000 * 60;

function getVersionUrl() {
	return `${environment.standaloneAppUrl}/static/version.json?t=${+new Date()}`;
}

interface VersionResponse {
	version: number;
}

export const useVersionInterval = () => {
	const isMountedRef = useRef(false);
	const versionRef = useRef(0);
	const snackbar = useSnackbar();
	const { t } = useTranslation();

	const showSnackbar = useCallback(() => {
		const snackbarParameters: CustomParameters = {
			autoHideDuration: TIME_UNTIL_REALOAD,
			alertSeverity: "info",
		};

		snackbar.showMessage(
			t("VersionProvider_Reload_Message", {
				seconds: Math.round(TIME_UNTIL_REALOAD / 1000),
			}),
			t("VersionProvider_Reload_Action"),
			() => {
				window.location.reload();
			},
			snackbarParameters
		);

		setTimeout(() => {
			if (isMountedRef.current) {
				window.location.reload();
			}
		}, TIME_UNTIL_REALOAD);
	}, [snackbar, t]);

	const getNextVersion = useCallback(async () => {
		if (isMountedRef.current && environment.standaloneAppUrl) {
			try {
				const response = await axios.get<VersionResponse>(getVersionUrl());

				if (
					versionRef.current !== 0 &&
					response.data.version > versionRef.current
				) {
					showSnackbar();
				}

				versionRef.current = response.data.version;
			} catch (error) {}
		}
	}, [showSnackbar]);

	useEffect(() => {
		isMountedRef.current = true;
		getNextVersion();
		const interval = setInterval(getNextVersion, POLLING_INTERVAL);

		return () => {
			isMountedRef.current = false;
			clearInterval(interval);
		};
	}, [getNextVersion]);
};
